import KeyboardDismissView from "@app/hoc/KeyboardDismissView"
import ScreenWrapper from "@app/hoc/ScreenWrapper"
import { PrivateStackParamList } from "@app/navigationApp/types"
import CommonHeader from "@app/sharedComponents/Header/Header"
import { ThemedText, ThemedView } from "@app/theme"
import { NativeStackScreenProps } from "@react-navigation/native-stack"
import { Platform, ScrollView } from "react-native"
import MutualFundList from "../UnlockLimitLanding/components/MutualFundsList/MutualFundsList"
import { Footer } from "./component/Footer"
import { addCommasToNumber, getDateMonthYearFromEpochFromMicroseconds, trackEvent } from "@app/utils"
import { RootState } from "@app/store/newstore"
import { useAppDispatch, useAppSelector } from "@app/store/hooks"
import { AssetRepositoryType } from "@voltmoney/micro-frontend/lib/configs/config"
import Button from "@app/sharedComponents/Button/Button"
import BottomSheetContainer from "@app/sharedComponents/Bottomsheet/Bottomsheet"
import FetchPortfolio from "../FetchPortfolio/FetchPortfolio"
import { useState } from "react"
import { AssetRepository } from "../FetchPortfolio/type"
import { useIsEnhanceLimit } from "@app/hooks/useIsEnhanceLimit"

type ProfolioFromRtaProps = NativeStackScreenProps<PrivateStackParamList, 'PORTFOLIO_FROM_RTA'> & {
    rta?: string
}

const ProfolioFromRta = ({ navigation, route }: ProfolioFromRtaProps) => {
    const rta = route?.params?.rta;
    const lastFetchedOn = getDateMonthYearFromEpochFromMicroseconds(route?.params?.lastFetchedOn || 0);
    const { authCAS } = useAppSelector((state: RootState) => state.application);

    const [isVisible, setIsVisible] = useState(false);

    const {isFromEnhanceLimit} = useIsEnhanceLimit()

    const availableAmount =
        rta === AssetRepositoryType.CAMS
            ? authCAS?.repositoryAssetMetadataMap?.CAMS?.availableCreditAmount
            : rta === AssetRepositoryType.MFCENTRAL
                ? authCAS && (authCAS?.repositoryAssetMetadataMap?.CAMS?.availableCreditAmount || 0) + (authCAS?.repositoryAssetMetadataMap?.KARVY?.availableCreditAmount || 0)
                : authCAS?.repositoryAssetMetadataMap?.KARVY?.availableCreditAmount;


    const totalPortfolio =
        rta === AssetRepositoryType.CAMS
            ? authCAS?.repositoryAssetMetadataMap?.CAMS?.availablePortfolioAmount
            : rta === AssetRepositoryType.MFCENTRAL
                ? authCAS && (authCAS?.repositoryAssetMetadataMap?.CAMS?.availablePortfolioAmount || 0) + (authCAS?.repositoryAssetMetadataMap?.KARVY?.availablePortfolioAmount || 0)
                : authCAS?.repositoryAssetMetadataMap?.KARVY?.availablePortfolioAmount;

    return (
        <>
            <ScreenWrapper screenName={route.name}>
                {/* <KeyboardDismissView> */}
                    <ThemedView flex={1} bg="bg-surface-primary">
                        <CommonHeader
                            label={`Portfolio from ${rta}`}
                            navigation={navigation}
                            pageName={route.name}
                        />
                        <ScrollView showsVerticalScrollIndicator={false}>
                            <ThemedView flex={1} bg="bg-fill-primary">
                                {/* Card */}
                                <ThemedView padding="lg" backgroundColor="bg-surface-page">
                                    <ThemedView borderColor="border-primary" paddingHorizontal="xl" backgroundColor="bg-fill-primary" justifyContent="space-between" padding="lg" style={{ borderRadius: 8, borderWidth: 1, display: 'flex', flexDirection: 'row' }}>
                                        <ThemedView flex={1} mr="2xl">
                                            <ThemedText variant='b4r' color="text-secondary">Value</ThemedText>
                                            <ThemedText variant='b3b' color="text-primary">₹{totalPortfolio && addCommasToNumber(totalPortfolio)}</ThemedText>
                                        </ThemedView>
                                        <ThemedView backgroundColor="bg-fill-primary" borderLeftWidth={1} borderColor="border-primary" flex={1} pl="2xl">
                                            <ThemedText variant='b4r' color="text-secondary">Available credit limit</ThemedText>
                                            <ThemedText variant='b3b' color="text-primary">₹{availableAmount && addCommasToNumber(availableAmount)}</ThemedText>
                                        </ThemedView>
                                    </ThemedView>
                                </ThemedView>
                                {/* Mutual fund list */}
                                <ThemedView padding="xl" paddingTop="2xl">
                                    <ThemedText variant='h5s' color="text-primary">
                                        Credit limit by mutual fund
                                    </ThemedText>
                                    <MutualFundList rta={rta} hideUsedLimit={true} />
                                </ThemedView>
                            </ThemedView>
                        </ScrollView>

                        <ThemedView borderTopColor="border-primary" style={{ padding: 16, borderTopWidth: 1 }} backgroundColor="bg-fill-primary">
                            <ThemedView flexDirection="row" justifyContent="center" alignItems="center" style={{ marginBottom: 8 }}>
                                <ThemedText variant='b4r' color="text-secondary" textAlign="center">
                                    Last fetched on
                                </ThemedText>
                                <ThemedText variant='b4s' color="text-primary" textAlign="center">
                                    {' '}{lastFetchedOn}
                                </ThemedText>
                            </ThemedView>
                        <Button
                            eventName={route.name + '_REFRESH_PORTFOLIO'}
                            additionalProperties={{source: rta}}
                            label={'Refresh portfolio'}
                            handlePress={() => {
                                if (rta === AssetRepository.MFCENTRAL) {
                                    if (Platform.OS === 'web') {
                                        navigation.navigate('MF_FETCH_PORTFOLIO', {})
                                    } else {
                                        if (isFromEnhanceLimit) {
                                            navigation.reset({
                                                index: 0,
                                                routes: [{ name: 'HOME' }, { name: 'MANAGE_LIMIT_LANDING' }, { name: 'MF_FETCH_PORTFOLIO' }]
                                            })
                                        } else {
                                            navigation.reset({
                                                index: 0,
                                                routes: [{ name: 'HOME' }, { name: 'MF_FETCH_PORTFOLIO' }]
                                            })
                                        }
                                    }
                                } else {
                                    setIsVisible(true)
                                }
                            }}
                                type={'SOLID'}
                                size='MD'
                                bg='bg-primary'
                                textColor='text-primary'
                                disabled={false}
                            />

                            <BottomSheetContainer
                                key={'portfolio-summary'}
                                isVisible={isVisible}
                                close={() => { setIsVisible(false) }}
                                closeOnBackdropPress={true}
                                showCloseIcon={true}
                                borderTopRightRadius={10}
                                borderTopLeftRadius={10}
                            >
                                <FetchPortfolio navigation={navigation} route={route}
                                    retryingFetchPortfolio={true}
                                    rtaToRetry={rta}
                                    onSuccessFetch={() => setIsVisible(false)}
                                />
                            </BottomSheetContainer>
                        </ThemedView>
                    </ThemedView>
                {/* </KeyboardDismissView> */}
            </ScreenWrapper>
        </>
    )
}

export default ProfolioFromRta

